import request from '@/utils/request'
import md5 from 'js-md5'
// 用户登录
export function postLogin(username, password, imgValidateCode) {
  var password = md5(password);
  var imgValidateCode = md5(imgValidateCode.toLowerCase());
  return request({
    url: '/user/login',
    method: 'post',
    // header: imgValidateCode,
    headers: {'imgValidateCode': imgValidateCode},
    data: {
      username,
      password
    }
  })
}
// 查询用户信息
export function getInfo(token) {
  return request({
    url: '/author/getUserByToken',
    method: 'get',
    params: {}
  })
}
// 登出
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}
// 验证码
export function getImgCode(width,height) {
  var width = width || "";
  var height = height || "";
  return process.env.BASE_API +'user/getImgValidate?interference_line_num=0&width='+ width +"&height="+ height +"&random="+ Math.random()
}

// 获取权限列表
export function GetPermission(token) {
  debugger;
  return request({
    url: '/author/getMenuTreeList',
    method: 'get',
    params: {}
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js